export const waybillTranslations = {
  es: {
    'hero-badge': '📋 DOCUMENTO CONTRACTUAL — Ley 15/2009',
    'hero-title': 'Carta de Porte digital nacional',
    'hero-subtitle': 'Qué es, requisitos (Ley 15/2009) y cómo emitirla electrónicamente con validez legal',
    'hero-check-1': 'Cumple Ley 15/2009',
    'hero-check-2': 'Firma electrónica eIDAS',
    'hero-check-3': 'Documento único (Contrato + Control)',
    'hero-check-4': 'Preparada para eFTI 2026',
    'hero-cta': 'Solicitar Demo Gratuita',
    
    'form-title': 'Solicitar información',
    'form-subtitle': 'Digitalice sus contratos de transporte',
    'form-name': 'Nombre completo',
    'form-company': 'Empresa',
    'form-email': 'Email corporativo',
    'form-phone': 'Teléfono',
    'form-terms': 'Acepto la',
    'form-terms-link': 'política de privacidad',
    'form-terms-text': 'y el tratamiento de mis datos para recibir información comercial sobre BlueCMR.',
    'form-submit': 'Solicitar Demo Gratuita',
    'form-submitting': 'Enviando...',
    'request-demo-btn': 'Solicitar demo',
    'request-trial-btn': 'Periodo de prueba',
    'select-interest': 'Seleccione una de las opciones:',
    'select-request-type': 'Por favor, selecciona si deseas una demo o un periodo de prueba.',
    'form-success': '¡Gracias! Hemos recibido tu solicitud correctamente.',
    'form-error': 'Error al enviar el formulario. Por favor, inténtalo de nuevo.',
    'form-wait': 'Por favor, espera unos segundos antes de enviar otro mensaje.',
    'form-review': 'Por favor, tómate un momento para revisar el formulario.',
    'form-attempts': 'Demasiados intentos. Por favor, recarga la página.',
    
    'what-title': '¿Qué es la Carta de Porte Nacional?',
    'what-intro': 'La <strong>Carta de Porte Nacional</strong> es el documento que formaliza el contrato de transporte por carretera dentro de España. Recoge:',
    'what-item-1': 'Condiciones pactadas entre cargador y transportista',
    'what-item-2': 'Descripción de la mercancía',
    'what-item-3': 'Bultos, peso, instrucciones especiales',
    'what-item-4': 'Reservas del conductor',
    'what-item-5': 'Responsabilidades de cada parte',
    'what-digital': 'La legislación española permite expresamente su emisión y firma en formato digital, siempre que se garantice autenticidad e integridad, algo que BlueCMR proporciona con firma avanzada eIDAS.',
    'what-control-title': 'Relación con el DeCA (documento de control digital)',
    'what-control-p1': 'Desde la Ley de Movilidad Sostenible, el documento de control debe ser digital (obligatorio en 2026). La normativa establece que <strong>si un documento contractual —como la Carta de Porte— contiene todos los datos obligatorios del DeCA, lo sustituye plenamente</strong>.',
    'what-control-p2': '<strong>Con BlueCMR:</strong> La Carta de Porte incluye automáticamente todos los campos exigidos por la Orden FOM/2861/2012 (Documento de Control) más los requisitos de los artículos 10 y 10 bis de la Ley 15/2009.',
    'what-control-p3': '👉 Una única Carta de Porte Digital = Contrato + DeCA',
    'what-control-p4': 'Esto elimina duplicidades y simplifica la gestión documental del transporte.',
    
    'legal-title': 'Marco legal',
    'legal-law-title': '📘 Ley 15/2009',
    'legal-law-desc': 'Contrato de transporte terrestre de mercancías. Define requisitos contractuales y emisión de la carta de porte.',
    'legal-rd-title': '🟦 RD-ley 14/2022',
    'legal-rd-desc': 'Introduce el artículo 10 bis con menciones obligatorias para contratos con porteador efectivo (>150€).',
    'legal-res-title': '📱 Resolución 05/06/2026',
    'legal-res-desc': 'Establece requisitos técnicos para documentos electrónicos de control administrativo (DeCA): PDF nativo digital, código QR con URL HTTPS y firma avanzada cuando proceda.',
    
    'content-title': 'Contenido obligatorio de la Carta de Porte',
    'content-art10-title': '📋 Artículo 10 - Menciones generales',
    'content-art10-1': 'Lugar y fecha de emisión',
    'content-art10-2': 'Nombre y dirección del cargador y expedidor',
    'content-art10-3': 'Nombre y dirección del porteador',
    'content-art10-4': 'Lugar y fecha de recepción de mercancía',
    'content-art10-5': 'Lugar y fecha prevista de entrega',
    'content-art10-6': 'Nombre y dirección del destinatario',
    'content-art10-7': 'Naturaleza, número de bultos y señales',
    'content-art10-8': 'Carácter peligroso de la mercancía (si aplica)',
    'content-art10-9': 'Cantidad (peso o expresión equivalente)',
    'content-art10-10': 'Clase de embalaje',
    'content-art10-11': 'Precio del transporte y gastos previsibles',
    'content-art10-12': 'Quién paga el transporte (cargador/destinatario)',
    
    'content-art10bis-title': '⚠️ Artículo 10 bis - Contratos con porteador efectivo (>150€)',
    'content-art10bis-intro': 'Cuando el precio del transporte supera 150€, son obligatorias estas menciones adicionales:',
    'content-art10bis-1': '<strong>NIF del cargador/expedidor y transportista efectivo</strong>',
    'content-art10bis-2': '<strong>Hora exacta</strong> de recepción y entrega prevista (además de fecha)',
    'content-art10bis-3': '<strong>Masa de las mercancías</strong> (o magnitud alternativa si no es determinable)',
    'content-art10bis-4': '<strong>Precio que cubra costes efectivos</strong> del porteador',
    
    'content-art11-title': '📄 Artículo 11 - Emisión y ejemplares',
    'content-art11-paper': 'Formato tradicional (papel):',
    'content-art11-paper-1': '<strong>3 ejemplares originales</strong> firmados por cargador y porteador',
    'content-art11-paper-2': '1º ejemplar: Cargador | 2º ejemplar: Viaja con mercancía | 3º ejemplar: Porteador',
    'content-art11-digital': '✨ Formato digital (Art. 15 + Resolución 05/06/2026):',
    'content-art11-digital-1': '<strong>Un único documento electrónico</strong> accesible por todas las partes',
    'content-art11-digital-2': '<strong>Formato digital verificable</strong> para inspecciones',
    'content-art11-digital-3': '<strong>Código QR</strong> con URL HTTPS para acceso instantáneo',
    'content-art11-digital-4': '<strong>Firma electrónica avanzada eIDAS</strong> (equivalente a manuscrita)',
    'content-art11-digital-5': 'Sin impresión ni distribución física de ejemplares',
    'content-art11-digital-6': 'Trazabilidad completa de cambios y versiones',
    
    'bluecmr-title': 'Carta de Porte Digital con BlueCMR',
    'bluecmr-creator-title': 'Para el creador del documento',
    'bluecmr-creator-1': 'Plantillas con datos predefinidos',
    'bluecmr-creator-2': 'Incluye todos los campos obligatorios de Carta de Porte y DeCA',
    'bluecmr-creator-3': 'Envío y firma de múltiples documentos simultáneamente',
    'bluecmr-creator-4': 'Integración vía API REST con sistemas TMS/ERP',
    
    'bluecmr-driver-title': 'Para el conductor',
    'bluecmr-driver-1': 'Firma electrónica avanzada sin instalaciones',
    'bluecmr-driver-2': 'Registro de incidencias y reservas durante el transporte',
    'bluecmr-driver-3': 'Actualización de matrículas y cambios de conductor',
    'bluecmr-driver-4': 'Fotografías de mercancía y documentos adjuntos',
    'bluecmr-driver-5': 'Funcionamiento offline con sincronización automática',
    
    'bluecmr-inspection-title': 'Para inspecciones',
    'bluecmr-inspection-intro': 'Cumplimiento de la Resolución de 5 de junio de 2026 sobre documentos electrónicos de control administrativo (DeCA):',
    'bluecmr-inspection-1': '<strong>Formato digital verificable</strong> para inspecciones',
    'bluecmr-inspection-2': '<strong>Código QR</strong> con URL del documento en repositorio HTTPS',
    'bluecmr-inspection-3': '<strong>Firmas electrónicas</strong> que permiten identificar al firmante y detectar modificaciones',
    'bluecmr-inspection-4': '<strong>Acceso instantáneo</strong> para Servicios de Inspección y fuerzas de vigilancia',
    'bluecmr-inspection-5': '<strong>Almacenamiento garantizado</strong> de datos y envío de documentos',
    
    'bluecmr-consignee-title': 'Para el destinatario',
    'bluecmr-consignee-1': 'Firma sin app ni instalación',
    'bluecmr-consignee-2': 'Enlace seguro por email o SMS',
    'bluecmr-consignee-3': 'Firma biométrica u OTP',
    'bluecmr-consignee-4': 'Copia automática tras la firma',
    
    'cta-title': 'Digitalice su Carta de Porte Nacional',
    'cta-subtitle': 'Genere, firme y archive sus Cartas de Porte con seguridad jurídica y sin duplicar documentos.',
    'cta-button': 'Solicitar demo gratuita',
    'cta-trial': 'Probar BlueCMR',
    
    'faq-title': 'Preguntas frecuentes sobre la Carta de Porte',
    'faq-1-q': '¿Es obligatoria la Carta de Porte en España?',
    'faq-1-a': 'Sí. El artículo 10 de la Ley 15/2009 establece que el contrato de transporte debe formalizarse por escrito mediante carta de porte. Su ausencia puede constituir infracción administrativa grave.',
    'faq-2-q': '¿Quién debe firmar la Carta de Porte?',
    'faq-2-a': 'Según el artículo 11 de la Ley 15/2009, la Carta de Porte debe ser firmada por el <strong>cargador y el porteador</strong>. El destinatario no firma la carta de porte como tal, sino que firma al recibir la mercancía (Art. 12) como acuse de recibo de la entrega.',
    'faq-3-q': '¿Puede la Carta de Porte sustituir al DeCA (documento de control)?',
    'faq-3-a': 'Sí. Una Carta de Porte digital que incluya todos los datos obligatorios del DeCA (Orden FOM/2861/2012) sustituye y cumple con la obligación legal. No es necesario llevar ambos documentos por separado.',
    'faq-4-q': '¿Cuándo aplica el artículo 10 bis (contratos >150€)?',
    'faq-4-a': 'Cuando el precio del transporte supera 150€ y se contrata con un porteador efectivo, son obligatorias menciones adicionales: NIF del cargador y transportista efectivo, hora exacta de recepción y entrega, masa de las mercancías y precio que cubra costes efectivos.',
    'faq-5-q': '¿Es válida la firma electrónica en la Carta de Porte?',
    'faq-5-a': 'Sí. El artículo 15 de la Ley 15/2009 permite expresamente la carta de porte electrónica, siempre que consista en un registro electrónico de datos transformables en signos legibles. La firma electrónica avanzada eIDAS tiene la misma validez legal que la firma manuscrita.',
    'faq-6-q': '¿Qué diferencia hay entre Carta de Porte y CMR?',
    'faq-6-a': 'La Carta de Porte es para transporte nacional (regulada por Ley 15/2009), mientras que el CMR es para transporte internacional (regulado por el Convenio CMR de 1956). Ambos formalizan el contrato de transporte, pero con ámbitos y normativas distintas.',
    'faq-7-q': '¿Cuánto tiempo hay que conservar la Carta de Porte?',
    'faq-7-a': 'Según el artículo 10 bis.6 de la Ley 15/2009, debe conservarse durante al menos 1 año. BlueCMR garantiza almacenamiento seguro y acceso permanente al documento.',
    
    'related-title': 'Artículos relacionados',
    'related-diferencias': 'Diferencias entre DeCA (antes DCA), Carta de Porte y CMR/eCMR',
    'related-diferencias-desc': 'Guía comparativa de los principales documentos de transporte',
    'related-doc-control': 'DeCA (Documento de Control Digital)',
    'related-doc-control-desc': 'Todo sobre el documento obligatorio para inspecciones en 2026',
    'related-ecmr': 'eCMR: Carta de porte internacional digital',
    'related-ecmr-desc': 'El documento contractual para transporte internacional',
    
    // Sección obligatoriedad
    'mandatory-title': '¿Es obligatoria la Carta de Porte en España?',
    'mandatory-yes-badge': 'SÍ es obligatoria',
    'mandatory-yes-text': 'El <strong>artículo 10 de la Ley 15/2009</strong> establece que cualquiera de las partes (cargador o porteador) podrá exigir la emisión de una carta de porte. En contratos con porteador efectivo y precio superior a 150€, el <strong>artículo 10 bis</strong> obliga a formalizarla por escrito con efectos probatorios.',
    'mandatory-fines-title': '⚠️ Consecuencias del incumplimiento',
    'mandatory-fines-text': 'No formalizar la carta de porte cuando es exigible puede constituir infracción según la Ley 16/1987 (LOTT). Además, el cargador y el porteador <strong>responden de los gastos y perjuicios</strong> que se deriven de la inexactitud o insuficiencia de los datos (Art. 10.7).',
    'mandatory-2026-title': '📅 En vigor desde el 5 de octubre de 2026',
    'mandatory-2026-text': 'Desde el <strong>5 de octubre de 2026</strong>, el Documento de Control de Transporte por Carretera es obligatoriamente digital: el DeCA (Ley de Movilidad Sostenible). Una Carta de Porte digital con todos los datos exigibles cumple ambas obligaciones en un solo documento.',
    
    // Cómo funciona (flujo)
    'flow-title': '¿Cómo funciona la Carta de Porte digital con BlueCMR?',
    'flow-intro': 'Un proceso 100% electrónico, válido legalmente y sin papel:',
    'flow-step1-title': '1. Creación del documento',
    'flow-step1-desc': 'El cargador o el transportista crea la Carta de Porte desde la web o app, o a través de la API REST integrada con su TMS/ERP. Se rellenan los datos obligatorios (artículos 10 y 10 bis) o se usa una plantilla con datos predefinidos.',
    'flow-step2-title': '2. Firma del cargador y del porteador',
    'flow-step2-desc': 'Las dos partes contractuales firman electrónicamente con firma avanzada eIDAS. El documento queda formalizado con efectos probatorios según el artículo 14 de la Ley 15/2009.',
    'flow-step3-title': '3. Transporte y eventos',
    'flow-step3-desc': 'Durante el transporte, el conductor puede registrar reservas, incidencias, fotografías, cambios de matrícula o de conductor. Todo queda trazado y firmado digitalmente.',
    'flow-step4-title': '4. Firma de entrega del destinatario',
    'flow-step4-desc': 'En destino, el destinatario firma el acuse de recibo de la mercancía (Art. 12) sin necesidad de instalar nada: enlace por email/SMS, firma biométrica u OTP.',
    'flow-step5-title': '5. Cierre y conservación',
    'flow-step5-desc': 'El documento se cierra automáticamente y se conserva con todas las evidencias durante el plazo legal mínimo de 1 año (Art. 10 bis.6). Acceso permanente y trazable para todas las partes.',
    
    // Casos prácticos
    'cases-title': 'Casos prácticos',
    'cases-intro': 'Cómo se aplica la Carta de Porte digital en situaciones reales:',
    'cases-1-title': '📦 Distribución capilar (cargador con flota propia)',
    'cases-1-desc': 'Una empresa cargadora reparte mercancía con sus propios vehículos en territorio nacional. La Carta de Porte digital sustituye al DeCA y aporta evidencia de entrega firmada por el destinatario en cada parada.',
    'cases-2-title': '🚛 Subcontratación con porteador efectivo',
    'cases-2-desc': 'Un operador logístico subcontrata el transporte a un transportista efectivo por un importe superior a 150€. El artículo 10 bis exige formalizar la carta de porte con menciones obligatorias adicionales (NIF, hora exacta, masa, precio efectivo).',
    'cases-3-title': '🏭 Integración con TMS/ERP',
    'cases-3-desc': 'Una empresa con sistema TMS/ERP genera cartas de porte automáticamente vía API REST. Cero entradas manuales, validación automática de datos obligatorios y firmas asíncronas en lote.',
    
    // Comparativa rápida
    'compare-title': 'Carta de Porte vs DeCA vs CMR',
    'compare-intro': 'Una visión rápida de los tres documentos del transporte por carretera:',
    'compare-cp-title': 'Carta de Porte',
    'compare-cp-scope': 'Nacional',
    'compare-cp-nature': 'Contractual',
    'compare-cp-law': 'Ley 15/2009',
    'compare-cp-signatures': 'Cargador y porteador',
    'compare-dc-title': 'DeCA (Documento de Control)',
    'compare-dc-scope': 'Nacional',
    'compare-dc-nature': 'Administrativo',
    'compare-dc-law': 'Orden FOM/2861/2012',
    'compare-dc-signatures': 'No requiere firmas',
    'compare-cmr-title': 'CMR / eCMR',
    'compare-cmr-scope': 'Internacional',
    'compare-cmr-nature': 'Contractual',
    'compare-cmr-law': 'Convenio CMR 1956',
    'compare-cmr-signatures': 'Expedidor y transportista',
    'compare-ambit': 'Ámbito',
    'compare-nature': 'Naturaleza',
    'compare-norm': 'Normativa',
    'compare-sign': 'Firmas',
    'compare-link': 'Ver comparativa completa →'
  },
  en: {
    'hero-badge': '📋 CONTRACTUAL TRANSPORT DOCUMENT IN SPAIN',
    'hero-title': 'Digital National Waybill',
    'hero-subtitle': 'What it is, requirements (Law 15/2009) and how to issue it electronically with legal validity',
    'hero-check-1': 'Complies with Law 15/2009',
    'hero-check-2': 'eIDAS electronic signature',
    'hero-check-3': 'Single document (Contract + Control)',
    'hero-check-4': 'Ready for eFTI 2026',
    'hero-cta': 'Request Free Demo',
    
    'form-title': 'Request information',
    'form-subtitle': 'Digitize your transport contracts',
    'form-name': 'Full name',
    'form-company': 'Company',
    'form-email': 'Corporate email',
    'form-phone': 'Phone',
    'form-terms': 'I accept the',
    'form-terms-link': 'privacy policy',
    'form-terms-text': 'and the processing of my data to receive commercial information about BlueCMR.',
    'form-submit': 'Request Free Demo',
    'form-submitting': 'Sending...',
    'request-demo-btn': 'Request demo',
    'request-trial-btn': 'Trial period',
    'select-interest': 'Select one of the options:',
    'select-request-type': 'Please select whether you want a demo or a trial period.',
    'form-success': 'Thank you! We have received your request successfully.',
    'form-error': 'Error sending the form. Please try again.',
    'form-wait': 'Please wait a few seconds before sending another message.',
    'form-review': 'Please take a moment to review the form.',
    'form-attempts': 'Too many attempts. Please reload the page.',
    
    'what-title': 'What is the National Waybill?',
    'what-intro': 'The <strong>National Waybill</strong> is the document that formalizes the road transport contract within Spain. It includes:',
    'what-item-1': 'Agreed conditions between shipper and carrier',
    'what-item-2': 'Description of the goods',
    'what-item-3': 'Packages, weight, special instructions',
    'what-item-4': 'Driver\'s reservations',
    'what-item-5': 'Responsibilities of each party',
    'what-digital': 'Spanish legislation expressly allows its issuance and signature in digital format, provided that authenticity and integrity are guaranteed, which BlueCMR provides with eIDAS advanced signature.',
    'what-control-title': 'Relationship with the Digital Control Document',
    'what-control-p1': 'Since the Sustainable Mobility Law, the Control Document must be digital (mandatory in 2026). The regulation establishes that <strong>if a contractual document —such as the Waybill— contains all the mandatory data of the Control Document, it fully replaces it</strong>.',
    'what-control-p2': '<strong>With BlueCMR:</strong> The Waybill automatically includes all fields required by Order FOM/2861/2012 (Control Document) plus the requirements of articles 10 and 10 bis of Law 15/2009.',
    'what-control-p3': '👉 A single Digital Waybill = Contract + Control Document',
    'what-control-p4': 'This eliminates duplications and simplifies transport document management.',
    
    'legal-title': 'Legal framework',
    'legal-law-title': '📘 Law 15/2009',
    'legal-law-desc': 'Land freight transport contract. Defines contractual requirements and waybill issuance.',
    'legal-rd-title': '🟦 Royal Decree-Law 14/2022',
    'legal-rd-desc': 'Introduces article 10 bis with mandatory mentions for contracts with effective carrier (>€150).',
    'legal-res-title': '📱 Resolution 05/06/2026',
    'legal-res-desc': 'Establishes technical requirements for electronic administrative control documents (DeCA): native digital PDF, QR code with HTTPS URL and advanced signature when applicable.',
    
    'content-title': 'Mandatory content of the Waybill',
    'content-art10-title': '📋 Article 10 - General mentions',
    'content-art10-1': 'Place and date of issue',
    'content-art10-2': 'Name and address of shipper and consignor',
    'content-art10-3': 'Name and address of carrier',
    'content-art10-4': 'Place and date of goods receipt',
    'content-art10-5': 'Place and expected date of delivery',
    'content-art10-6': 'Name and address of consignee',
    'content-art10-7': 'Nature, number of packages and marks',
    'content-art10-8': 'Dangerous nature of goods (if applicable)',
    'content-art10-9': 'Quantity (weight or equivalent expression)',
    'content-art10-10': 'Type of packaging',
    'content-art10-11': 'Transport price and foreseeable expenses',
    'content-art10-12': 'Who pays for transport (shipper/consignee)',
    
    'content-art10bis-title': '⚠️ Article 10 bis - Contracts with effective carrier (>€150)',
    'content-art10bis-intro': 'When the transport price exceeds €150, these additional mentions are mandatory:',
    'content-art10bis-1': '<strong>Tax ID of shipper/consignor and effective carrier</strong>',
    'content-art10bis-2': '<strong>Exact time</strong> of receipt and expected delivery (in addition to date)',
    'content-art10bis-3': '<strong>Mass of goods</strong> (or alternative magnitude if not determinable)',
    'content-art10bis-4': '<strong>Price covering effective costs</strong> of the carrier',
    
    'content-art11-title': '📄 Article 11 - Issuance and copies',
    'content-art11-paper': 'Traditional format (paper):',
    'content-art11-paper-1': '<strong>3 original copies</strong> signed by shipper and carrier',
    'content-art11-paper-2': '1st copy: Shipper | 2nd copy: Travels with goods | 3rd copy: Carrier',
    'content-art11-digital': '✨ Digital format (Art. 15 + Resolution 05/06/2026):',
    'content-art11-digital-1': '<strong>A single electronic document</strong> accessible by all parties',
    'content-art11-digital-2': '<strong>Verifiable digital format</strong> for inspections',
    'content-art11-digital-3': '<strong>QR code</strong> with HTTPS URL for instant access',
    'content-art11-digital-4': '<strong>eIDAS advanced electronic signature</strong> (equivalent to handwritten)',
    'content-art11-digital-5': 'No printing or physical distribution of copies',
    'content-art11-digital-6': 'Complete traceability of changes and versions',
    
    'bluecmr-title': 'Digital Waybill with BlueCMR',
    'bluecmr-creator-title': 'For the document creator',
    'bluecmr-creator-1': 'Templates with predefined data',
    'bluecmr-creator-2': 'Includes all mandatory fields of Waybill and Control Document',
    'bluecmr-creator-3': 'Sending and signing multiple documents simultaneously',
    'bluecmr-creator-4': 'REST API integration with TMS/ERP systems',
    
    'bluecmr-driver-title': 'For the driver',
    'bluecmr-driver-1': 'Advanced electronic signature without installations',
    'bluecmr-driver-2': 'Recording of incidents and reservations during transport',
    'bluecmr-driver-3': 'License plate updates and driver changes',
    'bluecmr-driver-4': 'Photographs of goods and attached documents',
    'bluecmr-driver-5': 'Offline operation with automatic synchronization',
    
    'bluecmr-inspection-title': 'For inspections',
    'bluecmr-inspection-intro': 'Compliance with Resolution of May 22, 2023 on control documents in electronic format:',
    'bluecmr-inspection-1': '<strong>Verifiable digital format</strong> for inspections',
    'bluecmr-inspection-2': '<strong>QR code</strong> with document URL in HTTPS repository',
    'bluecmr-inspection-3': '<strong>Electronic signatures</strong> that allow identifying the signer and detecting modifications',
    'bluecmr-inspection-4': '<strong>Instant access</strong> for Inspection Services and surveillance forces',
    'bluecmr-inspection-5': '<strong>Guaranteed storage</strong> of data and document sending',
    
    'bluecmr-consignee-title': 'For the consignee',
    'bluecmr-consignee-1': 'Signature without app or installation',
    'bluecmr-consignee-2': 'Secure link by email or SMS',
    'bluecmr-consignee-3': 'Biometric signature or OTP',
    'bluecmr-consignee-4': 'Automatic copy after signature',
    
    'cta-title': 'Digitize your National Waybill',
    'cta-subtitle': 'Generate, sign and archive your Waybills with legal security and without duplicating documents.',
    'cta-button': 'Request free demo',
    'cta-trial': 'Try BlueCMR',
    
    'faq-title': 'Frequently asked questions about the Waybill',
    'faq-1-q': 'Is the Waybill mandatory in Spain?',
    'faq-1-a': 'Yes. Article 10 of Law 15/2009 establishes that the transport contract must be formalized in writing by means of a waybill. Its absence may constitute a serious administrative offense.',
    'faq-2-q': 'Who must sign the Waybill?',
    'faq-2-a': 'According to Article 11 of Law 15/2009, the Waybill must be signed by the <strong>shipper and the carrier</strong>. The consignee does not sign the waybill itself, but signs upon receiving the goods (Art. 12) as proof of delivery.',
    'faq-3-q': 'Can the Waybill replace the Control Document?',
    'faq-3-a': 'Yes. A digital Waybill that includes all mandatory data from the Control Document (Order FOM/2861/2012) replaces and complies with the legal obligation. It is not necessary to carry both documents separately.',
    'faq-4-q': 'When does Article 10 bis apply (contracts >€150)?',
    'faq-4-a': 'When the transport price exceeds €150 and an effective carrier is contracted, additional mentions are mandatory: tax ID of shipper and effective carrier, exact time of receipt and delivery, mass of goods and price covering effective costs.',
    'faq-5-q': 'Is electronic signature valid for the Waybill?',
    'faq-5-a': 'Yes. Article 15 of Law 15/2009 expressly allows the electronic waybill, provided it consists of an electronic data record that can be transformed into legible signs. The eIDAS advanced electronic signature has the same legal validity as a handwritten signature.',
    'faq-6-q': 'What is the difference between a Waybill and a CMR?',
    'faq-6-a': 'The Waybill is for national transport (regulated by Law 15/2009), while the CMR is for international transport (regulated by the 1956 CMR Convention). Both formalize the transport contract, but with different scopes and regulations.',
    'faq-7-q': 'How long must the Waybill be kept?',
    'faq-7-a': 'According to Article 10 bis.6 of Law 15/2009, it must be kept for at least 1 year. BlueCMR guarantees secure storage and permanent access to the document.',
    
    'related-title': 'Related articles',
    'related-diferencias': 'Differences between DCA, Waybill and CMR/eCMR',
    'related-diferencias-desc': 'Comparative guide of the main transport documents',
    'related-doc-control': 'Digital Control Document',
    'related-doc-control-desc': 'Everything about the mandatory document for inspections in 2026',
    'related-ecmr': 'eCMR: International digital consignment note',
    'related-ecmr-desc': 'The contractual document for international transport',
    
    // Mandatory section
    'mandatory-title': 'Is the Waybill mandatory in Spain?',
    'mandatory-yes-badge': 'YES, it is mandatory',
    'mandatory-yes-text': '<strong>Article 10 of Law 15/2009</strong> establishes that any of the parties (shipper or carrier) may require the issuance of a waybill. In contracts with effective carrier and price exceeding €150, <strong>Article 10 bis</strong> requires its formalization in writing with probative effects.',
    'mandatory-fines-title': '⚠️ Consequences of non-compliance',
    'mandatory-fines-text': 'Failure to formalize the waybill when required may constitute an infringement under Law 16/1987 (LOTT). Furthermore, both shipper and carrier are <strong>liable for expenses and damages</strong> arising from inaccurate or insufficient data (Art. 10.7).',
    'mandatory-2026-title': '📅 In force since 5 October 2026',
    'mandatory-2026-text': 'Since <strong>5 October 2026</strong>, the Road Transport Control Document is mandatorily digital (Sustainable Mobility Law). A digital Waybill with all required data fulfills both obligations in a single document.',
    
    // How it works
    'flow-title': 'How does the digital Waybill work with BlueCMR?',
    'flow-intro': 'A 100% electronic process, legally valid and paperless:',
    'flow-step1-title': '1. Document creation',
    'flow-step1-desc': 'The shipper or carrier creates the Waybill from the web or app, or via REST API integrated with their TMS/ERP. Mandatory data (articles 10 and 10 bis) is filled in, or a template with predefined data is used.',
    'flow-step2-title': '2. Shipper and carrier signatures',
    'flow-step2-desc': 'Both contractual parties sign electronically with eIDAS advanced signature. The document is formalized with probative effects according to Article 14 of Law 15/2009.',
    'flow-step3-title': '3. Transport and events',
    'flow-step3-desc': 'During transport, the driver can record reservations, incidents, photographs, changes of license plate or driver. Everything is traced and digitally signed.',
    'flow-step4-title': '4. Consignee delivery signature',
    'flow-step4-desc': 'At destination, the consignee signs the proof of receipt of goods (Art. 12) without installing anything: link by email/SMS, biometric signature or OTP.',
    'flow-step5-title': '5. Closure and retention',
    'flow-step5-desc': 'The document is automatically closed and kept with all evidence during the minimum legal period of 1 year (Art. 10 bis.6). Permanent and traceable access for all parties.',
    
    // Practical cases
    'cases-title': 'Practical cases',
    'cases-intro': 'How the digital Waybill applies in real-world situations:',
    'cases-1-title': '📦 Capillary distribution (shipper with own fleet)',
    'cases-1-desc': 'A shipping company distributes goods with its own vehicles in national territory. The digital Waybill replaces the Control Document and provides delivery evidence signed by the consignee at each stop.',
    'cases-2-title': '🚛 Subcontracting with effective carrier',
    'cases-2-desc': 'A logistics operator subcontracts transport to an effective carrier for an amount exceeding €150. Article 10 bis requires formalizing the waybill with additional mandatory mentions (Tax ID, exact time, mass, effective price).',
    'cases-3-title': '🏭 Integration with TMS/ERP',
    'cases-3-desc': 'A company with a TMS/ERP system generates waybills automatically via REST API. Zero manual input, automatic validation of mandatory data and asynchronous batch signatures.',
    
    // Quick comparison
    'compare-title': 'Waybill vs Control Document vs CMR',
    'compare-intro': 'A quick view of the three road transport documents:',
    'compare-cp-title': 'Waybill',
    'compare-cp-scope': 'National',
    'compare-cp-nature': 'Contractual',
    'compare-cp-law': 'Law 15/2009',
    'compare-cp-signatures': 'Shipper and carrier',
    'compare-dc-title': 'Control Document',
    'compare-dc-scope': 'National',
    'compare-dc-nature': 'Administrative',
    'compare-dc-law': 'Order FOM/2861/2012',
    'compare-dc-signatures': 'No signatures required',
    'compare-cmr-title': 'CMR / eCMR',
    'compare-cmr-scope': 'International',
    'compare-cmr-nature': 'Contractual',
    'compare-cmr-law': 'CMR Convention 1956',
    'compare-cmr-signatures': 'Sender and carrier',
    'compare-ambit': 'Scope',
    'compare-nature': 'Nature',
    'compare-norm': 'Regulation',
    'compare-sign': 'Signatures',
    'compare-link': 'See full comparison →'
  }
};
